import { CommonModule } from '@angular/common';
import { Component, inject, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ResolveStart, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { PageConfig } from '@shared/interfaces/page-config.interface';
import { PageConfigService } from '@shared/services/page-config.service';
import { TooltipModule } from 'primeng/tooltip';
import { filter } from 'rxjs';
import { UserMenuComponent } from '../user-menu/user-menu.component';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, UserMenuComponent, TranslateModule, TooltipModule],
})
export class HeaderComponent {
  homePageUrl = '/';
  title: string = '';
  config: Signal<PageConfig>;
  showFeedbackWidget = !!environment.sentryUrl;

  #pageConfigService = inject(PageConfigService);
  #router = inject(Router);

  constructor() {
    this.config = this.#pageConfigService.pageConfig;

    this.#router.events
      .pipe(
        filter((event) => {
          return event instanceof ResolveStart;
        }),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.#pageConfigService.setPageConfig({});
      });
  }

  navigateByUrl(url: string): void {
    this.#router.navigateByUrl(url);
  }
}
